module.exports = "/static/assets/95ae02512eb2280da0b1eb0711ec948c.gif";